import { featuredPosts } from '@/mocks/home';
import Reveal from '@/components/base/Reveal';

export default function FeaturedSection() {
  const [mainPost, ...restPosts] = featuredPosts;

  return (
    <section id="featured" className="py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <Reveal>
          <div className="flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <span className="text-xs font-medium tracking-[0.2em] text-primary-600">
                热点爆料精选
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
                这一周被反复提起的那些事
              </h2>
              <p className="mt-4 max-w-2xl text-[15px] leading-8 text-foreground-700">
                不堆砌标题，只把每条爆料的关键节点讲清楚。以下是本周热度最高、脉络最完整的三条内容。
              </p>
            </div>
            <a
              href="#ranking"
              className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-foreground-800 transition-colors hover:text-primary-600"
            >
              全部爆料
              <i className="ri-arrow-right-line text-base" />
            </a>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <a
              href="#top"
              className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="h-[280px] w-full overflow-hidden md:h-[400px]">
                <img
                  src={mainPost.image}
                  alt="娱乐爆料专题配图"
                  title="顶流合约风波 娱乐爆料 44黑料区"
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-6 md:p-8">
                <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-600">
                  <span className="rounded-md bg-secondary-100 px-2.5 py-1 font-medium text-secondary-900">
                    {mainPost.tag}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line text-sm" />
                    {mainPost.readTime}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                  {mainPost.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-7 text-foreground-700">
                  {mainPost.excerpt}
                </p>
                <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-background-200 pt-5 text-xs text-foreground-600">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-fire-line text-sm text-primary-500" />
                    {mainPost.heat}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-chat-3-line text-sm" />
                    {mainPost.comments}
                  </span>
                </div>
              </div>
            </a>
          </Reveal>

          <div className="grid gap-6 lg:col-span-5">
            {restPosts.map((post, index) => (
              <Reveal key={post.id} delay={100 + index * 120}>
                <a
                  href="#top"
                  className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-primary-300 sm:flex-row"
                >
                  <div className="h-44 w-full shrink-0 overflow-hidden sm:h-auto sm:w-48">
                    <img
                      src={post.image}
                      alt={`${post.tag}爆料专题配图`}
                      title={`${post.title} 44黑料区`}
                      className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-5 md:p-6">
                    <span className="text-xs font-medium text-accent-700">{post.tag}</span>
                    <h3 className="mt-2.5 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                      {post.title}
                    </h3>
                    <p className="mt-2.5 flex-1 text-sm leading-6 text-foreground-600">
                      {post.excerpt}
                    </p>
                    <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
                      <span className="flex items-center gap-1.5">
                        <i className="ri-fire-line text-sm text-primary-500" />
                        {post.heat}
                      </span>
                      <span className="flex items-center gap-1.5">
                        <i className="ri-time-line text-sm" />
                        {post.readTime}
                      </span>
                    </div>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}